import { graphql } from "@cappelendamm/crystallize-types/orders/gql";
const GetMetaByOrderId = graphql(`
  query GetMetaByOrderId($orderId: ID!) {
    orders {
      get(id: $orderId) {
        meta {
          key
          value
        }
      }
    }
  }
`);
export default GetMetaByOrderId;
